// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"4de433ec","239":"48f74564","366":"127f2a76","389":"fe1b83a0","453":"4fe9681c","732":"1b9d88fa"}[chunkId] + ".chunk.js";
};